import React, { useEffect, useState } from "react"
import {
  GoogleMap,
  Marker,
  DirectionsRenderer,
  OverlayView,
  useJsApiLoader,
} from "@react-google-maps/api"
import Skeleton from "react-loading-skeleton"

const containerStyle = {
  width: "100%",
  height: "580px",
}

// Overlay position
const getOverlayPosition = (lat, lng) => ({
  lat: parseFloat(lat),
  lng: parseFloat(lng),
})

const libraries = ["places"];

// Label bubble component
const LabelBubble = ({ text, bg }) => (
  <div
    style={{
      background: bg || "#44d97b",
      color: "white",
      padding: "3px 10px",
      borderRadius: "8px",
      fontSize: "12px",
      fontWeight: "bold",
      whiteSpace: "nowrap",
      display: "inline-block",
      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
      minWidth: "30px",
      textAlign: "center",
    }}
  >
    {text}
  </div>
)

const TrackingRouteMap = ({ booking, loading, drivers }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    libraries
  })

  const [directions, setDirections] = useState(null)

  // useEffect(() => {
  //   if (isLoaded && booking?.source_lat && booking?.source_long) {
  //     const directionsService = new window.google.maps.DirectionsService()

  //     directionsService.route(
  //       {
  //         origin: {
  //           lat: parseFloat(booking.source_lat),
  //           lng: parseFloat(booking.source_long),
  //         },
  //         destination: {
  //           lat: parseFloat(booking.dest_lat),
  //           lng: parseFloat(booking.dest_long),
  //         },
  //         travelMode: window.google.maps.TravelMode.DRIVING,
  //       },
  //       (result, status) => {
  //         if (status === "OK" && result) {
  //           setDirections(result)
  //         } else {
  //           console.error("Directions request failed due to", status)
  //         }
  //       }
  //     )
  //   }
  // }, [isLoaded, booking])

  if (!isLoaded) return <Skeleton count={1} height={550} />

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={{
        lat: parseFloat(booking?.source_lat || "24.9593711"),
        lng: parseFloat(booking?.source_long || "67.1216471"),
      }}
      zoom={13}
    >
      {/* Drivers Vehicles + labels */}
      {drivers.map(item => (
        <React.Fragment key={item.id}>
          <Marker
            position={{ lat: item?.latitude, lng: item?.longitude }}
            icon={{
              url:
                // item?.vehicle?.category_image,
                "https://l7a.9bd.mytemp.website/dev/framework/public/storage/vehicle-types/eihlnzoVtQWBc4YPx1L2V5QcTRY2hWE854sxU41G.png",
              scaledSize: new window.google.maps.Size(32, 32),
            }}
          />
          <OverlayView
            position={getOverlayPosition(item?.latitude, item?.longitude)}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            getPixelPositionOffset={(width, height) => ({
              x: -(width / 2),
              y: -50 // move label 40px above the marker
            })}
          >
            <LabelBubble text={item?.status} bg={item?.status == "free" ? "#66BB6A" : "#EF5350"} />
          </OverlayView>
        </React.Fragment>
      ))}

      {/* Highlighted route */}
      {/* {directions && (
        <DirectionsRenderer
          directions={directions}
          options={{
            polylineOptions: {
              strokeColor: "#28a745",
              strokeWeight: 5,
            },
            suppressMarkers: true, // no default A/B markers
          }}
        />
      )} */}

      {/* Pickup marker + label */}
      {booking?.source_lat && booking?.source_long && (
        <>
          <Marker
            position={{
              lat: parseFloat(booking.source_lat),
              lng: parseFloat(booking.source_long),
            }}
          />
          <OverlayView
            position={getOverlayPosition(
              booking.source_lat,
              booking.source_long
            )}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <LabelBubble text="Pickup" bg="#007bff" />
          </OverlayView>
        </>
      )}

      {/* Dropoff marker + label */}
      {booking?.dest_lat && booking?.dest_long && (
        <>
          <Marker
            position={{
              lat: parseFloat(booking.dest_lat),
              lng: parseFloat(booking.dest_long),
            }}
          />
          <OverlayView
            position={getOverlayPosition(booking.dest_lat, booking.dest_long)}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <LabelBubble text="Dropoff" bg="#6f42c1" />
          </OverlayView>
        </>
      )}

    </GoogleMap>
  )
}

export default TrackingRouteMap
